var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZhaoze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34631275",
    d: "M2.13371 2.6015C2.16804 2.35431 2.37939 2.17029 2.62895 2.17029H13.371C13.6206 2.17029 13.832 2.35431 13.8663 2.6015L15.3468 13.2608C15.3885 13.5615 15.155 13.8296 14.8515 13.8296H1.14849C0.844996 13.8296 0.611491 13.5615 0.653242 13.2608L2.13371 2.6015Z",
    fill: "#4D4035",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 78",
    d: "M6.8125 10.0824C6.8125 11.0034 6.06589 11.75 5.1449 11.75C4.22391 11.75 3.47729 11.0034 3.47729 10.0824C3.47729 9.16141 5.1449 7.23358 5.1449 7.23358C5.1449 7.23358 6.8125 9.16141 6.8125 10.0824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 79",
    d: "M8.77136 5.41705C8.77136 6.01515 8.28651 6.5 7.68842 6.5C7.09032 6.5 6.60547 6.01515 6.60547 5.41705C6.60547 4.81896 7.68842 3.56702 7.68842 3.56702C7.68842 3.56702 8.77136 4.81896 8.77136 5.41705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 80",
    d: "M12.1305 8.55C12.1305 9.21274 11.5932 9.75 10.9305 9.75C10.2677 9.75 9.73047 9.21274 9.73047 8.55C9.73047 7.88726 10.9305 6.5 10.9305 6.5C10.9305 6.5 12.1305 7.88726 12.1305 8.55Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhaoze);
export default __webpack_public_path__ + "static/media/zhaoze.bd940bf33553f7719be536ba5065ee68.svg";
export { ForwardRef as ReactComponent };